import { render, staticRenderFns } from "./cSelect.vue?vue&type=template&id=4cb4ffa2&scoped=true"
import script from "./cSelect.vue?vue&type=script&lang=js"
export * from "./cSelect.vue?vue&type=script&lang=js"
import style0 from "./cSelect.vue?vue&type=style&index=0&id=4cb4ffa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4ffa2",
  null
  
)

export default component.exports